<section class="p-5 bg-vtmn-play-content-inverse">
  <app-attendee-city-autocomplete
    class="block mb-3"
    [ariaLabel]="'a11y.attendee.filters.city.input.label' | translate"
    [placeholder]="'attendee.filters.city.input.placeholder' | translate"
    (selectedPlace)="selectPlace($event)"
    (selectedRadius)="selectRadius($event)"
    [defaultPlaceValue]="city"
    [defaultPlaceId]="placeId"
    [defaultRadiusValue]="radius"
    (isCleared)="handleAutocompleteClear()"
  ></app-attendee-city-autocomplete>

  <app-attendee-sports-groups-autocomplete
    class="block mb-3"
    [ariaLabel]="'a11y.attendee.filters.sport.input.label' | translate"
    [placeholder]="'attendee.filters.sport.input.placeholder' | translate"
    (selected)="selectSportsGroup($event)"
    [selectedIdentifier]="sportsGroup"
  ></app-attendee-sports-groups-autocomplete>

  <app-attendee-date-range-input
    [ariaLabel]="'a11y.attendee.filters.date_range.input.label' | translate"
    [placeholder]="'attendee.filters.date_range.input.placeholder' | translate"
    (selected)="selectDateRange($event)"
    [defaultFrom]="dateRange?.from"
    [defaultTo]="dateRange?.to"
  ></app-attendee-date-range-input>

  <button
    *ngIf="!isSearchAuto"
    class="block mt-4 mx-auto"
    [class.w-full]="isMobileDevice"
    app-vtmn-play-button
    type="button"
    [size]="vtmnPlayButtonSize.MEDIUM"
    [shape]="
      isMobileDevice ? vtmnPlayButtonShape.SQUARED : vtmnPlayButtonShape.ROUNDED
    "
    (click)="search()"
    data-test="search"
  >
    {{ 'attendee.filters.button.search' | translate }}
  </button>
</section>
